module.exports = __webpack_public_path__ + "static/the-22-immutable-laws-of-marketing-62837afdc6cbf9b6891e18fe8ee2cf47.jpg";